import React, { useState } from 'react';
import { Box } from '@mui/material';
import { ZSpinner } from '@marageti/z4-lib';
import { TravelPreferenceSections } from '@marageti/z4-sdk/lib/people';
import useTravelerProfile from '../../hooks/use-traveler-profile';
import TravelPreferencesCardView from './travel-preferences-card-view';
import {
  CATEGORIES, CategoryConfig, buildHtmlText, buildPlainText, copyRichText,
} from './utils';

type TravelPreferencesCardProps = {
  travelerId: string;
  canEdit: boolean;
};

const TravelPreferencesCard = ({ travelerId, canEdit }: TravelPreferencesCardProps) => {
  const { travelerProfile, updateTravelerProfile } = useTravelerProfile(travelerId);

  const [openCategory, setOpenCategory] = useState<CategoryConfig | null>(null);
  const [copied, setCopied] = useState(false);

  if (!travelerProfile) {
    return (
      <Box
        sx={{
          bgcolor: 'background.paper',
          borderRadius: '12px',
          p: 3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 160,
        }}
      >
        <ZSpinner />
      </Box>
    );
  }

  const handleCopy = async () => {
    const html = buildHtmlText(CATEGORIES, travelerProfile.travelPreferences);
    const plain = buildPlainText(CATEGORIES, travelerProfile.travelPreferences);
    await copyRichText(html, plain);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleSave = async (categoryKey: keyof TravelPreferenceSections, value: string) => {
    await updateTravelerProfile(
      {
        travelPreferences: {
          ...travelerProfile.travelPreferences,
          [categoryKey]: value,
        },
      },
      'Could not save travel preferences.',
      'Preferences saved',
    );
  };

  const handleModalSave = async (value: string) => {
    if (!openCategory) return;
    await handleSave(openCategory.key, value);
    setOpenCategory(null);
  };

  return (
    <TravelPreferencesCardView
      travelerProfile={travelerProfile}
      canEdit={canEdit}
      copied={copied}
      openCategory={openCategory}
      onCopy={handleCopy}
      onEditCategory={setOpenCategory}
      onCloseModal={() => setOpenCategory(null)}
      onModalSave={handleModalSave}
    />
  );
};

export default TravelPreferencesCard;
